<template>
  <div>
    <div>
      <strong class="text-[15px]">
        Tự động tối ưu Quảng cáo bằng Atosa Agent AI
      </strong>
    </div>

    <div class="priority mt-[30px] relative overflow-hidden">
      <div>
        <div class="flex gap-[15px] flex-wrap justify-between">
          <div v-for="item in mode_list" :key="item.value"
               style="flex: 0 0 calc(50% - 10px);"
               class="border border-[#e5e5e5] p-[15px] rounded-[4px] flex flex-col gap-[10px]"
          >
            <div class="flex justify-between items-center">
              <div class="flex gap-[10px] items-center cursor-pointer"
                   @click="(!item.locked && m__is_match_mode(item.value)) && (form_auto_by_ai.mode = item.value)"
                   :style="!m__is_match_mode(item.value) ? 'opacity: 0.5; cursor: not-allowed' : ''">
                <input type="radio" v-model="form_auto_by_ai.mode" :name="item.value" :value="item.value"
                       class="m-0 w-[14px] h-[14px]"
                       :disabled="item.locked || !m__is_match_mode(item.value)">
                <strong class="text-[14px]" :style="{color: item.color}">Chế độ {{ item.text }}</strong>
              </div>

              <div v-if="c__current_package_mode === item.value" class="flex items-center">
                <span class="ai-tag leading-[20px]">Đang sử dụng</span>
              </div>
              <div v-else class="flex items-center cursor-pointer"
                   @click="m__redirect_to_buy_atosa_agent()">
                <span class="grey-tag leading-[20px]">Mua gói để kích hoạt</span>
              </div>
            </div>
            <div class="leading-[25px] h-[80px] pt-[5px]"
                 :style="!m__is_match_mode(item.value) ? 'opacity: 0.5' : ''">
              <span class="text-[13px] text-[#666]">
                {{ item.description }}
              </span>
              <br>
              <strong class="text-[12px] text-[#666]"
                      @click="open_link('https://www.messenger.com/t/104406444763487')">
                {{ item.locked ? item.locked_message : '' }}
              </strong>
            </div>
            <div class="text-[13px] leading-[25px] text-[#666]"
                 :style="!m__is_match_mode(item.value) ? 'opacity: 0.5' : ''">
              - Tùy chỉnh Ngày hoạt động: &nbsp;
              <span class="text-[14px] text-[#000]">{{ item.config_type ? '✅' : '❌' }}</span>
              <br>
              - Tùy chỉnh Thời gian hoạt động: &nbsp;
              <span class="text-[14px] text-[#000]">{{ item.config_time ? '✅' : '❌' }}</span>
              <br>
              - Bảo hiểm rủi ro: &nbsp;
              <span class="text-[14px] text-[#000]">{{ item.config_risk ? '✅' : '❌' }}</span>
              <br>
              - Tuần xuất hoạt động: &nbsp;
              <span class="text-[13px] text-[#000]">{{ item.config_period }}</span>
              <br>
              - Chi phí: &nbsp;
              <span class="text-[13px] text-[#000]">
                {{ item.config_cost }}% doanh thu chiến dịch / ngày
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col mt-[40px]">
        <div class="flex gap-[20px] items-stretch">
          <div class="flex-1 max-w-[50%] min-h-full flex flex-col pt-[10px]">
            <div>
              <span class="text-[13px] font-bold">Cài đặt mục tiêu ROAS</span>
            </div>
            <div class="mt-[5px] text-[#666]">
              Hệ thống sẽ tối ưu dựa trên mục tiêu ROAS tháng của chiến dịch
            </div>
            <div class="flex-1 mt-[10px] p-[20px] bg-[#f5f4ff] rounded-t-[10px]"
                 style="background-image: repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 0px, rgba(255, 255, 255, 0.15) 1px, transparent 1px, transparent 10px);">
              <div class="flex flex-col gap-[20px]">
                <div class="flex gap-0 items-start">
                  <el-radio v-model="form_auto_by_ai.target_roas" label="roas_1" class="w-[91px]">
                    ROAS = {{ roas_list[0] | to_fixed(1) }}
                  </el-radio>
                  <div class="text-[#666]">
                    Gợi ý dựa trên kết quả trong quá khứ
                  </div>
                </div>

                <div class="flex gap-0 items-start">
                  <el-radio v-model="form_auto_by_ai.target_roas" label="roas_2" class="w-[91px]">
                    ROAS = {{ roas_list[1] | to_fixed(1) }}
                  </el-radio>
                  <div class="text-[#666]">
                    Gợi ý dựa trên kết quả trong quá khứ
                  </div>
                </div>

                <div class="flex gap-0 items-start">
                  <el-radio v-model="form_auto_by_ai.target_roas" label="roas_3" class="w-[91px]">
                    ROAS = {{ roas_list[2] | to_fixed(1) }}
                  </el-radio>
                  <div class="text-[#666]">
                    Gợi ý tốc độ tăng trưởng hợp lý
                  </div>
                </div>

                <div class="flex gap-0 items-start">
                  <el-radio v-model="form_auto_by_ai.target_roas" label="custom" class="w-[140px] min-w-[91px]"
                            @change="form_auto_by_ai.selected_target_roas = 0;">
                    Tùy chọn
                  </el-radio>
                  <div class="text-[#666] h-[35px] overflow-hidden">
                    Phù hợp khi bạn có sản phẩm vào mùa, trend, cần đẩy, ngày sale, hết mùa.
                  </div>
                </div>
                <div v-if="form_auto_by_ai.target_roas === 'custom'" class="text-[#666] flex-auto">
                  <el-input size="mini" class="w-[300px]" v-model="form_auto_by_ai.target_roas_custom"
                            :disabled="form_auto_by_ai.target_roas !== 'custom'" type="number"
                            placeholder="Nhập ROAS tùy chỉnh"></el-input>
                </div>

                <div v-if="c__roas_is_high_template" class="flex gap-[20px] items-center">
                  <div class="text-[#666] flex-auto">
                    <div class="text-warning pr-[40px] text-[13px] py-[3px]">
                      Bạn đang đặt mục tiêu ROAS quá cao. Điều này có thể khiến quảng cáo khó hiển thị, hạn chế chi
                      tiêu và làm giảm khả năng đạt được kết quả mong muốn.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-1 max-w-[50%] min-h-full flex flex-col pt-[10px]">
            <div>
              <span class="text-[13px] font-bold">Cài đặt mục tiêu GMV</span>
            </div>
            <div class="mt-[5px] text-[#666]">
              Hệ thống sẽ tối ưu dựa trên mục tiêu GMV tháng của chiến dịch
            </div>
            <div class="flex-1 mt-[10px] p-[20px] bg-[#f5f4ff] rounded-t-[10px]"
                 style="background-image: repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 0px, rgba(255, 255, 255, 0.15) 1px, transparent 1px, transparent 10px);">
              <div class="flex flex-col gap-[20px]">
                <div class="flex gap-[20px] items-start">
                  <el-radio v-model="form_auto_by_ai.target_gmv" label="gmv_1" class="w-[140px]">
                    GMV = {{ m__calculate(gmv_list[0]) | currency }}
                  </el-radio>
                </div>

                <div class="flex gap-[20px] items-start">
                  <el-radio v-model="form_auto_by_ai.target_gmv" label="gmv_2" class="w-[140px]">
                    GVM = {{ m__calculate(gmv_list[1]) | currency }}
                  </el-radio>
                </div>

                <div class="flex gap-[20px] items-start">
                  <el-radio v-model="form_auto_by_ai.target_gmv" label="gmv_3" class="w-[140px]">
                    GVM = {{ m__calculate(gmv_list[2]) | currency }}
                  </el-radio>
                </div>

                <div class="flex gap-[20px] items-start">
                  <el-radio v-model="form_auto_by_ai.target_gmv" label="custom" class="w-[140px] min-w-[140px]"
                            @change="form_auto_by_ai.selected_target_gmv = 0">
                    Tùy chọn
                  </el-radio>
                  <div class="text-[#666] h-[35px] overflow-hidden">
                    &nbsp;
                  </div>
                </div>
                <div v-if="form_auto_by_ai.target_gmv === 'custom'" class="text-[#666] flex-auto">
                  <el-input v-model="form_auto_by_ai.target_gmv_custom" v-number-format
                            size="mini" class="w-[300px]" placeholder="Nhập GMV tùy chỉnh"
                            :disabled="form_auto_by_ai.target_gmv !== 'custom'"></el-input>
                </div>

                <div v-if="c__gmv_is_high_template" class="flex gap-[20px] items-center">
                  <div class="text-[#666] flex-auto">
                    <div class="text-warning pr-[40px] text-[13px] py-[3px]">
                      Mục tiêu GMV bạn điền đang lớn hơn mức GMV trung bình có thể hạn chế việc hiển thị và chi tiêu
                      của quảng cáo hoặc khó đạt được mục tiêu.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="false" class="flex gap-[20px] mt-[5px]">
          <el-button type="text" size="mini" :loading="loading.recommend_target" @click="m__refresh_recommend_target()">
            <i class="el-icon-refresh font-bold !text-[#337ab7]"></i>
            <strong class="text-primary">Cập nhật lại mục tiêu đề xuất</strong>
          </el-button>
        </div>

        <div v-if="true" class="flex flex-col gap-[5px]">
          <div class="flex gap-[20px] items-stretch">
            <div class="flex-1 max-w-[50%] min-h-full bg-[#e0deff] rounded-b-[10px] pt-[20px] px-[20px] pb-[20px]">
              <div>
                <span class="text-[13px]">👉&nbsp; Mục tiêu ROAS đang áp dụng:</span>
                &nbsp;
                <span class="text-[13px] font-bold">
                  {{ form_auto_by_ai.selected_target_roas ? form_auto_by_ai.selected_target_roas.toFixed(1) : 0 }}
                </span>
              </div>
            </div>

            <div class="flex-1 max-w-[50%] min-h-full bg-[#e0deff] rounded-b-[10px] pt-[20px] px-[20px] pb-[20px]">
              <div>
                <span class="text-[13px]">👉&nbsp; Mục tiêu GMV đang áp dụng:</span>
                &nbsp;
                <span class="text-[13px] font-bold">
                  {{
                    form_auto_by_ai.selected_target_gmv ? m__calculate(form_auto_by_ai.selected_target_gmv) : 0 |
                      currency
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-[20px]">
        <div class="flex items-stretch gap-[20px]">
          <div class="flex-1">
            <div class="mt-[20px]">
              <strong class="text-[14px]">
                Cài đặt mục tiêu ưu tiên
              </strong>
              <span class="text-[red]">*</span>
            </div>
            <div class="w-[300px] pt-[10px]">
              <el-select class="w-full" size="mini" value="" filterable v-model="form_auto_by_ai.target">
                <el-option value="both" :label="'⚡ Kết hợp cả ROAS và GMV'"></el-option>
                <el-option value="roas" :label="'🎯 Ưu tiên ROAS (Tối ưu lợi nhuận)'"></el-option>
                <el-option value="gmv" :label="'📈 Ưu tiên GMV (Tăng trưởng doanh số)'"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-[45px]">
        <div class="flex items-stretch gap-[20px]">
          <div class="flex-1">
            <div class="mb-[5px] flex gap-[10px] items-center">
              <!--              <el-switch v-model="form_auto_by_ai.allow_cpc_control"></el-switch>-->
              <strong class="text-[14px] cursor-pointer"
                      @click="form_auto_by_ai.allow_cpc_control = !form_auto_by_ai.allow_cpc_control">
                Cài đặt giá thầu từ khóa
              </strong>
            </div>

            <div class="p-[15px] rounded-[4px] bg-[#f5f4ff] mt-[10px]">
              <div class="w-[65%] text-[#333]">
                Nhằm đảm bảo giá thầu hoạt động trong mức cho phép vào ngày thường và ngày sale, tránh làm giảm traffic
                của từ khóa cũng như kiểm soát CPC tuần, tháng của từ khóa.
              </div>
              <div class="flex items-stretch mt-[30px] mb-[10px] gap-[20px]">
                <div class="flex-1">
                  <strong>Từ khóa chính xác</strong>

                  <div class="flex flex-col gap-[15px] mt-[20px]">
                    <div class="flex gap-[10px] items-center">
                      <span class="w-[140px] font-semibold">Giá thầu tối thiểu:</span>
                      <el-input
                        v-model="form_auto_by_ai.min_cpc_math_type_0"
                        type="number"
                        size="mini"
                        class="w-[220px]"
                        placeholder="Nhập giá thầu tối thiểu (Không bắt buộc)"
                      ></el-input>
                    </div>
                    <div class="flex gap-[10px] items-center">
                      <span class="w-[140px] font-semibold">Giá thầu tối đa:</span>
                      <el-input
                        v-model="form_auto_by_ai.max_cpc_math_type_0"
                        type="number"
                        size="mini"
                        class="w-[220px]"
                        placeholder="Nhập giá thầu tối đa (Không bắt buộc)"
                      ></el-input>
                    </div>
                    <div class="flex gap-[10px] items-center">
                      <span class="w-[140px] font-semibold">Giá thầu tối đa ngày sale:</span>
                      <el-input
                        v-model="form_auto_by_ai.max_cpc_math_type_0_spd"
                        type="number"
                        size="mini"
                        class="w-[220px]"
                        placeholder="Nhập giá thầu tối đa ngày sale (Không bắt buộc)"
                      ></el-input>
                    </div>
                    <div v-if="false" class="flex gap-[10px] items-center">
                      <span class="w-[140px] font-semibold">CPC tối đa (theo tháng):</span>
                      <el-input
                        v-model="form_auto_by_ai.max_cpc_month_math_type_0"
                        type="number"
                        size="mini"
                        class="w-[220px]"
                        placeholder="Nhập cpc tối đa (Không bắt buộc)"
                      ></el-input>
                    </div>
                  </div>
                </div>

                <div class="flex-1">
                  <strong>Từ khóa mở rộng</strong>

                  <div class="flex flex-col gap-[15px] mt-[20px]">
                    <div class="flex gap-[10px] items-center">
                      <span class="w-[140px] font-semibold">Giá thầu tối thiểu:</span>
                      <el-input
                        v-model="form_auto_by_ai.min_cpc_math_type_1"
                        type="number"
                        size="mini"
                        class="w-[220px]"
                        placeholder="Nhập giá thầu tối thiểu (Không bắt buộc)"
                      ></el-input>
                    </div>
                    <div class="flex gap-[10px] items-center">
                      <span class="w-[140px] font-semibold">Giá thầu tối đa:</span>
                      <el-input
                        v-model="form_auto_by_ai.max_cpc_math_type_1"
                        type="number"
                        size="mini"
                        class="w-[220px]"
                        placeholder="Nhập giá thầu tối đa (Không bắt buộc)"
                      ></el-input>
                    </div>
                    <div class="flex gap-[10px] items-center">
                      <span class="w-[140px] font-semibold">Giá thầu tối đa ngày sale:</span>
                      <el-input
                        v-model="form_auto_by_ai.max_cpc_math_type_1_spd"
                        type="number"
                        size="mini"
                        class="w-[220px]"
                        placeholder="Nhập giá thầu tối đa ngày sale (Không bắt buộc)"
                      ></el-input>
                    </div>
                    <div v-if="false" class="flex gap-[10px] items-center">
                      <span class="w-[140px] font-semibold">CPC tối đa (theo tháng):</span>
                      <el-input
                        v-model="form_auto_by_ai.max_cpc_month_math_type_1"
                        type="number"
                        size="mini"
                        class="w-[220px]"
                        placeholder="Nhập cpc tối đa (Không bắt buộc)"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-[5px] mt-[50px]">
        <div class="mb-[5px] flex gap-[10px] items-center">
          <el-switch v-model="form_auto_by_ai.allow_risk_control"></el-switch>
          <strong class="text-[14px] cursor-pointer"
                  @click="form_auto_by_ai.allow_risk_control = !form_auto_by_ai.allow_risk_control">
            Cài đặt bảo hiểm rủi ro
          </strong>
        </div>

        <div class="p-[15px] rounded-[4px] bg-[#f5f4ff] mt-[5px]">
          <div class="w-[65%] text-[#333]">
            Khi kích hoạt, hệ thống sẽ tự động điều chỉnh thuật toán hoặc tạm dừng quảng cáo khi phát hiện hiệu suất
            giảm mạnh, giúp giảm thiểu rủi ro và tối ưu chi phí.
          </div>
          <div v-if="form_auto_by_ai.allow_risk_control">
            <div class="py-[20px] rounded-[4px] flex flex-col gap-[10px]">
              <div class="flex gap-[10px] items-center  pt-[10px]">
                <span class="w-[140px] font-semibold">ROAS tối thiểu:</span>
                <el-input
                  v-model="form_auto_by_ai.min_roas"
                  type="number"
                  size="mini"
                  class="w-[250px]"
                  placeholder="Nhập ROAS tối thiểu"
                ></el-input>
              </div>

              <div v-if="false" class="flex gap-[10px] items-center  pt-[10px]">
                <span class="w-[140px] font-semibold">GMV tháng tối thiểu:</span>
                <el-input
                  v-model="form_auto_by_ai.min_gmv"
                  type="number"
                  size="mini"
                  class="w-[250px]"
                  placeholder="Nhập GMV tháng tối thiểu"
                ></el-input>
              </div>

              <div class="flex gap-[10px] items-center pt-[10px]">
                <span class="w-[140px] font-semibold">Gửi cảnh báo rủi ro tới:</span>
                <div class="flex flex-col gap-[10px]">
                  <el-select
                    v-model="form_auto_by_ai.send_alert_to"
                    size="mini"
                    class="w-[250px]"
                    value=""
                  >
                    <el-option label="Email" value="email"></el-option>
                    <!-- <el-option label="Zalo" value="zalo"></el-option> -->
                    <el-option label="Lark" value="lark"></el-option>
                    <el-option label="Telegram" value="telegram"></el-option>
                  </el-select>
                </div>
              </div>

              <div class="flex gap-[10px] items-center">
                <span class="w-[140px] font-semibold">&nbsp;</span>
                <div class="flex flex-col gap-[10px]">
                  <el-input
                    v-if="form_auto_by_ai.send_alert_to === 'email'"
                    v-model="form_auto_by_ai.alert_config.email"
                    size="mini"
                    class="w-[250px]"
                    placeholder="Nhập email"
                  ></el-input>

                  <el-input
                    v-if="form_auto_by_ai.send_alert_to === 'zalo'"
                    v-model="form_auto_by_ai.alert_config.zalo"
                    size="mini"
                    class="w-[250px]"
                    placeholder="Nhập SĐT"
                  ></el-input>

                  <el-input
                    v-if="form_auto_by_ai.send_alert_to === 'lark'"
                    v-model="form_auto_by_ai.alert_config.lark_webhook"
                    size="mini"
                    class="w-[250px]"
                    placeholder="Nhập Lark Webhook URL"
                  ></el-input>

                  <el-input
                    v-if="form_auto_by_ai.send_alert_to === 'telegram'"
                    v-model="form_auto_by_ai.alert_config.telegram_bot_token"
                    size="mini"
                    class="w-[250px]"
                    placeholder="Nhập bot token"
                  ></el-input>

                  <el-input
                    v-if="form_auto_by_ai.send_alert_to === 'telegram'"
                    v-model="form_auto_by_ai.alert_config.telegram_chat_id"
                    size="mini"
                    class="w-[250px]"
                    placeholder="Nhập chat id"
                  ></el-input>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div v-if="form_auto_by_ai.mode !== 'eco'" class="flex flex-col gap-[5px] mt-[40px]">
        <div class="mb-[5px]">
          <strong class="text-[14px]">
            Tuần xuất hoạt động
          </strong>
          <span class="text-[red]">*</span>
        </div>

        <div class="flex gap-[15px]">
          <div class="w-[300px]">
            <el-select
              class="w-full"
              size="mini"
              value=""
              filterable
              v-model="form_auto_by_ai.type"
            >
              <el-option value="flash_sale" :label="$t('day.flash_sale')"></el-option>
              <el-option value="mini_spike_day" :label="$t('day.mini_spike_day')"></el-option>
              <el-option value="remain" :label="$t('day.every_day')"></el-option>
              <el-option value="exclude_sale" :label="$t('day.exclude_sale')"></el-option>
              <el-option value="from_to" :label="$t('day.from_to')"></el-option>
            </el-select>
          </div>

          <div class="w-[350px]">
            <el-date-picker
              v-if="form_auto_by_ai.type === 'from_to'"
              v-model="form_auto_by_ai.daterange"
              class="w-full"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('base.start_time')"
              :end-placeholder="$t('base.end_time')"
              size="mini"
              format="dd-MM-yyyy"
            ></el-date-picker>
          </div>
        </div>
      </div>

      <div v-if="form_auto_by_ai.mode !== 'eco'" class="flex flex-col gap-[5px] mt-[40px]">
        <div class="leading-[20px]">
          <strong class="text-[14px]">
            Thời gian hoạt động
          </strong>
          <br>
          <span class="text-[12px] text-[#666]">
            Chỉ dành cho chế độ Ultra
          </span>
          <span class="text-[red]">*</span>
        </div>

        <div class="p-[15px] px-[20px] rounded-[4px] bg-[#f5f4ff]">
          <div class="mt-0">
            <div>
              <el-radio
                v-model="form_auto_by_ai.radio"
                label="1"
                :disabled="form_auto_by_ai.mode === 'eco'"
              >
                Liên tục
              </el-radio>
            </div>
            <div class="mt-[5px]">
              Tự động tối ưu quảng cáo cả ngày
            </div>
          </div>

          <div class="mt-[20px]">
            <div>
              <el-radio
                v-model="form_auto_by_ai.radio"
                label="2"
                :disabled="form_auto_by_ai.mode === 'eco'"
              >
                {{ $t('base.optional') }}
              </el-radio>
            </div>
            <div class="mt-[5px]">
              Tự động tối ưu ads theo thời gian mong muốn
            </div>
          </div>
        </div>

        <div v-if="form_auto_by_ai.radio === '2'" class="my-[10px] bg-white">
          <CustomDateTimePicker
            :mode="form_auto_by_ai.type === 'from_to' ? 'daterange' : 'week'"
            :daterange="form_auto_by_ai.daterange"
            :daterange_type.sync="form_auto_by_ai.datetimes_daterange_type"
            :value.sync="form_auto_by_ai.datetimes"
          ></CustomDateTimePicker>
        </div>
      </div>


      <div class="flex flex-col gap-[5px] mt-[30px]">
        <div>
          <strong class="text-[14px]">
            Tên cấu hình
          </strong>
          <span class="text-[red]">*</span>
        </div>
        <div class="max-w-[300px]">
          <el-input
            size="mini"
            placeholder="Nhập tên cấu hình"
            v-model="form_auto_by_ai.name"
          ></el-input>
        </div>
      </div>

      <!--      <div class="absolute bottom-[-83px] right-[-77px] rotate-[-30deg] opacity-[0.268]">
              <svg width="522" height="522" viewBox="0 0 200 222" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.8">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 68.4223C0 52.1626 13.2094 38.9815 29.5039 38.9815H170.496C186.791 38.9815 200 52.1626 200 68.4223V191.713C200 207.973 186.791 221.154 170.496 221.154H29.5039C13.2093 221.154 0 207.973 0 191.713V68.4223ZM172.108 90.7198L86.2917 176.352L28.5127 126.933L42.9133 110.169L85.1343 146.28L156.461 75.1064L172.108 90.7198Z"
                        fill="#e0deff"/>
                </g>
              </svg>
            </div>-->
    </div>

    <div class="mt-[25px] text-right">
      <el-button size="mini" icon="el-icon-close" @click="m__close_self()">
        {{ $t('base.close') }}
      </el-button>
      <el-button type="primary" size="mini" icon="el-icon-check" @click="m__confirm_add_config()">
        {{ $t('base.save_config') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { make_uuid } from '../../../addon/ads_function'
import CustomDateTimePicker from './component_custom_datetime_picker.vue'
import { fix_ads_mixins } from '../../../mixins/fix_ads'

export default {
  name: 'component__auto_by_ai',

  mixins: [fix_ads_mixins],

  components: {
    CustomDateTimePicker: CustomDateTimePicker,
  },

  props: {
    shop: null,
    selected_config: null,
    atosa_agent_package: null,
    campaign_id: null,
    recommend_roas: {
      type: Array,
      default: () => [],
    },
    recommend_gmv: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    return {
      state: 'create',

      form_auto_by_ai: {
        config_id: make_uuid(),
        created_time: this.dayjs().unix(),
        type: 'remain',
        daterange: null,
        radio: '1',
        name: '',
        feature: {
          max_revenue: false,
          optimize_cost: false,
          increase_traffic: false,
          optimize_roas_cir: false,
        },
        config_status: 1,
        times: [
          {
            start_time: '00:00',
            end_time: '24:00',
          }],
        start_time: '',
        end_time: '',
        mode: '',
        target: 'both',
        target_period: 'month',
        target_roas: null,
        target_gmv: null,
        target_roas_custom: null,
        target_gmv_custom: null,
        selected_target_roas: null,
        selected_target_gmv: null,
        datetimes: [],
        datetimes_daterange_type: 'group',
        allow_cpc_control: false,
        allow_risk_control: false,
        max_cir: null,
        min_roas: null,
        min_gmv: null,
        max_price: null,
        max_cpc: null,
        min_cpc_math_type_0: null,
        min_cpc_math_type_1: null,
        max_cpc_math_type_0: null,
        max_cpc_math_type_0_spd: null,
        max_cpc_math_type_1: null,
        max_cpc_math_type_1_spd: null,
        max_cpc_month_math_type_0: null,
        max_cpc_month_math_type_1: null,
        send_alert_to: 'email',
        alert_config: {
          email: '',
          zalo: '',
          lark_webhook: '',
          telegram_bot_token: '',
          telegram_chat_id: '',
        },
      },

      mode_list: [
        {
          value: 'eco',
          text: 'ECO',
          color: '#28a745',
          description: 'Atosa Agent AI sẽ tự động tối ưu quảng cáo một cách ổn định, bám sát kế hoạch đặt ra, đảm bảo hiệu quả bền vững.',
          locked: false,
          config_type: false,
          config_time: false,
          // config_period: '30 phút/lần',
          config_period: 'Ổn định',
          config_cost: 1,
          config_risk: true,
        },
        {
          value: 'ultra',
          text: 'ULTRA',
          color: '#e74c3d',
          description: 'Atosa Agent AI sẽ tự động tối ưu quảng cáo với tốc độ cao và hiệu suất vượt trội, đảm bảo bứt phá mạnh mẽ so với kế hoạch ban đầu.',
          locked: false,
          locked_message: 'Nhấn vào đây để liên hệ với Atosa ngay và mở khóa chế độ đặc biệt dành riêng cho bạn.',
          config_type: true,
          config_time: true,
          // config_period: '15 phút/lần',
          config_period: 'Nhanh',
          config_cost: 1.5,
          config_risk: true,
        },
      ],

      roas_list: [0, 0, 0],
      gmv_list: [0, 0, 0],

      loading: { recommend_target: false },
    }
  },

  mounted () {
    if (this.selected_config) {
      this.form_auto_by_ai = this.clone(this.selected_config)
      this.state = 'edit'
    }

    this.form_auto_by_ai.mode = this.atosa_agent_package && this.atosa_agent_package.extra_data
      ? this.atosa_agent_package.extra_data.mode
      : ''
    this.form_auto_by_ai.alert_config.email = this.$store.state.userInfo.email
    this.form_auto_by_ai.alert_config.zalo = this.$store.state.userInfo.phone

    if (this.recommend_roas && this.recommend_roas.length > 1) this.roas_list = this.recommend_roas
    if (this.recommend_gmv && this.recommend_gmv.length > 1) this.gmv_list = this.recommend_gmv

    if (!this.form_auto_by_ai.selected_target_roas) {
      if (this.form_auto_by_ai.target_roas === 'roas_1') this.form_auto_by_ai.selected_target_roas = this.roas_list[0]
      if (this.form_auto_by_ai.target_roas === 'roas_2') this.form_auto_by_ai.selected_target_roas = this.roas_list[1]
      if (this.form_auto_by_ai.target_roas === 'roas_3') this.form_auto_by_ai.selected_target_roas = this.roas_list[2]
      if (this.form_auto_by_ai.target_roas ===
        'custom') this.form_auto_by_ai.selected_target_roas = +this.form_auto_by_ai.target_roas_custom || 0
    }

    if (!this.form_auto_by_ai.selected_target_gmv) {
      if (this.form_auto_by_ai.target_gmv === 'gmv_1') this.form_auto_by_ai.selected_target_gmv = this.gmv_list[0]
      if (this.form_auto_by_ai.target_gmv === 'gmv_2') this.form_auto_by_ai.selected_target_gmv = this.gmv_list[1]
      if (this.form_auto_by_ai.target_gmv === 'gmv_3') this.form_auto_by_ai.selected_target_gmv = this.gmv_list[2]
      if (this.form_auto_by_ai.target_gmv ===
        'custom') this.form_auto_by_ai.selected_target_gmv = +this.form_auto_by_ai.target_gmv_custom || 0
    }

    this.form_auto_by_ai.target_roas = null
    this.form_auto_by_ai.target_gmv = null

    // if (!this.form_auto_by_ai.target_roas === 'custom') this.form_auto_by_ai.target_roas = null
    // if (!this.form_auto_by_ai.target_gmv === 'custom') this.form_auto_by_ai.target_gmv = null
  },

  watch: {
    'atosa_agent_package': function (new_value) {
      if (new_value) {
        this.form_auto_by_ai.mode = new_value.extra_data ? new_value.extra_data.mode : ''
      }
    },

    'form_auto_by_ai': {
      deep: true,
      immediate: true,
      handler () {
        if (this.form_auto_by_ai.target_roas === 'roas_1') this.form_auto_by_ai.selected_target_roas = this.roas_list[0]
        else if (this.form_auto_by_ai.target_roas ===
          'roas_2') this.form_auto_by_ai.selected_target_roas = this.roas_list[1]
        else if (this.form_auto_by_ai.target_roas ===
          'roas_3') this.form_auto_by_ai.selected_target_roas = this.roas_list[2]
        else if (this.form_auto_by_ai.target_roas === 'custom') {
          if (+this.form_auto_by_ai.target_roas_custom) {
            this.form_auto_by_ai.selected_target_roas = +this.form_auto_by_ai.target_roas_custom || 0
          } else {
            this.form_auto_by_ai.selected_target_roas = 0
          }
        }

        if (this.form_auto_by_ai.target_gmv === 'gmv_1') this.form_auto_by_ai.selected_target_gmv = this.gmv_list[0]
        else if (this.form_auto_by_ai.target_gmv ===
          'gmv_2') this.form_auto_by_ai.selected_target_gmv = this.gmv_list[1]
        else if (this.form_auto_by_ai.target_gmv ===
          'gmv_3') this.form_auto_by_ai.selected_target_gmv = this.gmv_list[2]
        else if (this.form_auto_by_ai.target_gmv === 'custom') {
          if (+this.form_auto_by_ai.target_gmv_custom) {
            this.form_auto_by_ai.selected_target_gmv = +this.form_auto_by_ai.target_gmv_custom || 0
          } else {
            this.form_auto_by_ai.selected_target_gmv = 0
          }
        }

        // todo: test
        // this.roas_list = [0, 0, 0]
        // this.gmv_list = [0, 0, 0]
      },
      // end handler
    },
  },

  computed: {
    c__current_package_mode () {
      return this.atosa_agent_package && this.atosa_agent_package.extra_data
        ? this.atosa_agent_package.extra_data.mode
        : ''
    },

    c__show_advance_fixed () {
      const fixed_list = ['vuducminhdev07', 'ads.atosa14@gmail.com', 'kydopal@gmail.com']
      return fixed_list.includes(this.$store.state.userInfo.username)
    },

    c__roas_is_high_template () {
      if (this.roas_list.every(i => i === 0) &&
        (+this.form_auto_by_ai.selected_target_roas > 10 || +this.form_auto_by_ai.target_roas_custom > 10)) {
        return true
      }

      const last_roas = this.roas_list[this.roas_list.length - 1]

      if (this.form_auto_by_ai.target_roas === 'custom') {
        return +last_roas && +last_roas > 0 && +this.form_auto_by_ai.target_roas_custom > (+last_roas * 1.3) &&
          +this.form_auto_by_ai.target_roas_custom > 16
      }

      return +last_roas && +last_roas > 0 && +this.form_auto_by_ai.selected_target_roas > (+last_roas * 1.3) &&
        +this.form_auto_by_ai.selected_target_roas > 16
    },

    c__gmv_is_high_template () {
      if (this.gmv_list.every(i => i === 0)) {
        return false
      }

      const last_gmv = this.gmv_list[this.gmv_list.length - 1]

      if (this.form_auto_by_ai.target_gmv === 'custom') {
        return +last_gmv && +last_gmv > 0 && +this.form_auto_by_ai.target_gmv_custom > (+last_gmv * 1.3)
      }

      return +last_gmv && +last_gmv > 0 && +this.form_auto_by_ai.selected_target_gmv > (+last_gmv * 1.3)
    },

    c__roas_is_high () {
      const last_roas = this.roas_list[this.roas_list.length - 1]

      return this.roas_list.every(i => i === 0)
        ? +this.form_auto_by_ai.selected_target_roas > 10
        : +this.form_auto_by_ai.selected_target_roas > (+last_roas * 1.3) &&
        +this.form_auto_by_ai.selected_target_roas > 16
    },

    c__gmv_is_high () {
      const last_gmv = this.gmv_list[this.gmv_list.length - 1]

      return this.gmv_list.every(i => i === 0)
        ? false
        : +this.form_auto_by_ai.selected_target_gmv > (+last_gmv * 1.3)
    },
  },

  methods: {
    async m__refresh_recommend_target () {
      try {
        await this.$confirm(
          `Bạn có chắc chắn muốn cập nhật lại mục tiêu được đề xuất không? Lưu ý: các đề xuất cũ sẽ bị mất!`,
          this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
      } catch (e) {
        return
      }

      this.loading.recommend_target = true
      try {
        const recommend_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/atosa_agent/recommend_target',
          {
            shop_id: this.shop._id,
            campaign_id: this.campaign_id,
            override: true,
          }, this.cf())
        this.roas_list = recommend_response.body.data.roas_list
        this.gmv_list = recommend_response.body.data.gmv_list
        this.ntf_s('Đã cập nhật lại mục tiêu đề xuất')
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.recommend_target = false
      }
    },

    async m__redirect_to_buy_atosa_agent () {
      try {
        await this.$confirm(
          `Gói sản phẩm sẽ chỉ kích hoạt riêng cho từng shop, bạn có chắc chắn muốn mua gói cho shop "${this.shop.username}" không?`,
          this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
          })
      } catch (e) {
        return
      }

      this.open_link(`https://banhang.atosa.asia/authenticate/handle?redirect=${encodeURIComponent(
        `/payment/transfer?channel=atosa_agent&extra=${JSON.stringify(
          { shop_id: this.shop._id })}`)}&token=${this.$store.state.userInfo.token}`)
    },

    m__is_match_mode (mode) {
      return this.c__current_package_mode === mode
    },

    m__confirm_add_config () {
      if (this.form_auto_by_ai.mode === 'eco') {
        this.form_auto_by_ai.type = 'remain'
        this.form_auto_by_ai.radio = '1'
      }

      if (!this.form_auto_by_ai.name) {
        this.ntf_w(this.$t('required.config_name'))
        return
      }

      if (this.form_auto_by_ai.radio === '2' && this.form_auto_by_ai.datetimes.length === 0) {
        this.ntf_w(this.$t('required.period_times'))
        return
      }

      if (!+this.form_auto_by_ai.selected_target_roas) {
        this.ntf_w('Vui lòng chọn hoặc điền mục tiêu ROAS')
        return
      }
      if (!+this.form_auto_by_ai.selected_target_gmv) {
        this.ntf_w('Vui lòng chọn hoặc điền mục tiêu GMV')
        return
      }
      if (this.form_auto_by_ai.mode === 'eco') {
        if (this.c__roas_is_high) {
          this.ntf_w(
            'Bạn đang đặt mục tiêu ROAS quá cao. Điều này có thể khiến quảng cáo khó hiển thị, hạn chế chi tiêu và làm giảm khả năng đạt được kết quả mong muốn. Vui lòng sử dụng chế độ Ultra để thực hiện mục tiêu này!')
          return
        }
        if (this.c__gmv_is_high) {
          this.ntf_w(
            'Mục tiêu GMV bạn điền đang lớn hơn mức GMV trung bình có thể hạn chế việc hiển thị và chi tiêu của quảng cáo hoặc khó đạt được mục tiêu. Vui lòng sử dụng chế độ Ultra để thực hiện mục tiêu này!')
          return
        }
      }

      if (this.form_auto_by_ai.allow_risk_control) {
        if (!+this.form_auto_by_ai.min_roas) {
          this.ntf_w('Vui lòng nhập mức ROAS tối thiểu cho cài đặt bảo hiểm rủi ro')
          return
        }

        if (+this.form_auto_by_ai.min_roas >= +this.form_auto_by_ai.selected_target_roas * 0.70) {
          this.ntf_w('Mức ROAS tối thiểu phải thấp hơn mục tiêu ROAS 30%')
          return
        }
      }

      // if (this.form_auto_by_ai.radio === '2' && this.form_auto_by_ai.times.length === 0) {
      //   this.ntf_w(this.$t('required.time'))
      //   return
      // }

      // let not_select_feature_yet = true
      // for (const key of Object.keys(this.form_auto_by_ai.feature)) {
      //   if (this.form_auto_by_ai.feature[key]) {
      //     not_select_feature_yet = false
      //     break
      //   }
      // // }
      //
      // if (not_select_feature_yet) {
      //   this.ntf_w(this.$t('required.feature'))
      //   return
      // }

      this.$emit('confirm_add_auto_by_ai_config', {
        state: this.state,
        config: this.form_auto_by_ai,
      })
    },

    m__close_self () {
      this.$emit('close_dialog')
    },
  },
}
</script>

<style>
.priority > div:not(:last-child) {
  position: relative;
  z-index: 2;
}

.priority > div:last-child {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/pas/component/component_auto_by_ai.vue